import messages from '../../locale/messages';

const validateStep2 = values => {

  const errors = {}

  return errors
}

export default validateStep2
